import { getGlobal } from './modules/utils';

const globals = getGlobal();

function env(key = "") {
  return key?.trim().length ? globals._env_[key.trim()] : globals._env_;
}

export default env;
